<!--
    描述：系统首页-项目列表
    时间：2020-03-16
    Created by ws
-->
<template>
	<div class="w-page-main">
		<!-- 顶部搜索栏 -->
		<div class="w-page-header">
			<div class="left-tabs overflow-hidden">
				<span @click="changeTab(1)"
					  :class="{'is-active': curTab === 1}">卡片</span>
				<span @click="changeTab(2)"
					  :class="{'is-active': curTab === 2}">列表</span>
			</div>
			<search-area ref="searchContent"
						 searchName="pname"
						 :showMore="false"
						 placeholderName="项目名称"
						 @on-search="onSearch"
						 @on-refresh="onRefresh"
						 @on-reset="onReset"
						 @on-input="onInput">
				<!-- <el-form slot="searchform"
						 :model="searchForm"
						 label-width="90px">
					<el-form-item label="项目名称"
								  prop="pname">
						<el-input placeholder="请输入"
								  v-model="searchForm.pname"></el-input>
					</el-form-item>
					<el-form-item label="委托单位"
								  prop="client">
						<el-input placeholder="请输入"
								  v-model="searchForm.client"></el-input>
					</el-form-item>
				</el-form> -->
			</search-area>
			<div class="btnGroups ml10">
				<el-button type="primary"
						   size="small"
						   @click="dialogObj.visible = true">新增</el-button>
			</div>
		</div>

		<!-- 新增、编辑等弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   :close-on-click-modal="false"
				   @closed="handleClose"
				   center>

			<!-- 弹窗组件 -->
			<add-project v-if="dialogObj.visible"
						 :mode="dialogObj.type"
						 :projectId="dialogObj.curProjectId"
						 ref="addProject"
						 @onSuccess="onSuccess"
						 @onWait="onWaiting"></add-project>

			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center"
				 v-if="dialogObj.type !== 'view'">
				<el-button size="small"
						   @click="dialogObj.visible = false">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doSave">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 下方内容 -->
		<div class="w-page-container">
			<el-scrollbar class="h100">
				<div style="height: 1000px">66666</div>
			</el-scrollbar>
		</div>
	</div>
</template>

<script>
import searchArea from 'components/searchArea/searchArea'
import projectList from './components/project_list'
import addProject from './components/add_dialog'

import { mapActions } from 'vuex'
import { searchProject, saveProject } from 'api/modules/dataProject.js'
export default {
	name: 'Home',
	components: {
		searchArea,
		projectList,
		addProject
	},
	data() {
		return {
			// 搜索表单
			searchForm: {
				pname: '',
				client: ''
			},
			// 当前选中的tab
			curTab: 1,
			dialogFormVisible: false,
			projectForm: {},
			dialogObj: {
				curProjectId: '',
				title: '新增项目',
				visible: false,
				width: '650px',
				type: 'add'
			},
			btnLoading: false
		}
	},
	activated() {
		// console.log('进入缓存页面了')
	},
	methods: {
		// 切换tab 选项
		changeTab(val) {
			this.curTab = val
		},
		// 确认搜索
		onSearch() {
			this.$refs.projectList.doSearch()
			// console.log(this.searchForm)
			// searchProject('/1/10', this.searchForm).then(res => {
			// 	this.tableObj.tableData = res.data.records;
			// })
		},
		// 点击刷新
		onRefresh() {
			this.onReset()
			this.onSearch()
		},
		// 点击重置
		onReset() {
			this.searchForm.pname = ''
			this.searchForm.client = ''
		},
		// 筛选框输入事件
		onInput(val, attr) {
			this.searchForm[attr] = val
		},

		// 项目列表操作事件
		rowClick(row, type) {
			this.dialogObj.type = type
			this.dialogObj.curProjectId = row.id
			this.dialogObj.title = type === 'view' ? '查看项目信息' : '编辑项目信息'
			this.dialogObj.visible = true
		},

		// 关闭弹窗事件
		handleClose() {
			this.dialogObj.visible = false
			this.dialogObj.title = '新增项目'
			this.dialogObj.type = 'add'
			this.dialogObj.width = '650px'
			this.btnLoading = false
		},
		
		// 保存项目
		doSave() {
			this.btnLoading = true
			this.$refs.addProject.doSave()
		},

		// 保存成功回调
		onSuccess() {
			this.btnLoading = false
			this.dialogObj.visible = false
			this.$refs.projectList.doSearch()
		},

		// 验证失败时 回调
		onWaiting() {
			setTimeout(() => {
				this.btnLoading = false
			}, 1000)
		}
	},
	watch: {
		'searchForm.pname': {
			handler: function(val) {
				this.$refs.searchContent.sname = val
			},
			deep: true
		}
	}
}
</script>

<style scoped lang="less">
</style>

